module.exports = __webpack_public_path__ + "img/single-star.41ac5609.svg";